module.exports = __webpack_public_path__ + "img/pr-7.9e6e7d1c.png";